import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { backUrl } from "../../config";

const redPath = "raschetApi"; // change
const tagApi = "raschets"; // change

export const raschetApi = createApi({
  // change
  reducerPath: redPath,
  baseQuery: fetchBaseQuery({
    baseUrl: backUrl,
    tagTypes: [tagApi],
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.accessToken;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (build) => ({
    getRaschet: build.query({
      // change
      query: (param) => `${tagApi}${param ? param : ""}`,
      providesTags: [tagApi],
    }),
    createRaschet: build.mutation({
      // change
      query: (newData) => ({
        url: `${tagApi}`,
        method: "POST",
        body: {
          data: {
            ...newData,
          },
        },
      }),
      invalidatesTags: [tagApi],
    }),
    updateRaschet: build.mutation({
      // change
      query: (newData) => ({
        url: `${tagApi}/${newData.id}`,
        method: "PUT",
        body: {
          data: {
            ...newData.updated,
          },
        },
      }),
      invalidatesTags: [tagApi],
    }),
  }),
});

export const {
  useGetRaschetQuery,
  useCreateRaschetMutation,
  useUpdateRaschetMutation,
} = raschetApi; // change
